<template>
    <department-dialog-selector
        v-model="dialogVisible"
        :multiple="multiple"
        :group-data="selectorData"
        @on-confirm="onConfirm"
        :title="title"
        @on-select-item="onSelectItem"
        :before-confirm="beforeConfirm"
    ></department-dialog-selector>
</template>

<script>
import UtilsMixins from '@/mixins/utils'
import departmentDialogSelector from './department-dialog-selector.vue'
    export default {
        data() {
            return {
                multiple: true,
                dialogVisible: false,
                selectorData: [],
                title: '选择部门',
                beforeConfirm: undefined
            }
        },
        mixins: [UtilsMixins],
        components: {
            departmentDialogSelector
        },
        methods: {
            show(params) {
                let { loadData, multiple, title, beforeConfirm } = params;
                if(multiple !== undefined) {
                    this.multiple = multiple;
                }
                if(title !== undefined) {
                    this.title = title;
                }
                this.beforeConfirm = beforeConfirm;
                if (loadData) {
                    loadData(this.loadDataCallback);
                }
                this.dialogVisible = true;
            },
            loadDataCallback(data) {
                this.selectorData = data;
            },
            onConfirm(data, shortcutValue) {
                console.log(data);
                this.resolve({
                selectValue: data, 
                shortcutValue,
            });
            },
            onSelectItem(data) {
                this.resolve(data);
            }
        }
    }
</script>

<style lang="scss">

</style>
